import { Layout } from 'components/universal/layout';
import {
    PATHS,
    PATHS_HAND_HYGIENE,
    PATH_FIVEMOMENTSHANDHYGIENE,
    PATH_HANDHYGIENEANDMEDICALGLOVES,
    PATH_INTRODUCTION,
    PATH_PREPARINGYOURHANDSTOWORK,
    PATH_PROPERHANDDISINFECTION,
    PATH_PROPERHANDWASHING,
} from 'constants/routes';
import PrivateRoute from 'features/private-route';
import { AboutAction } from 'pages/about-action';
import { Basket } from 'pages/basket';
import { ConfirmEmailAddress } from 'pages/confirm-email-address';
import { ConfirmResetPassword } from 'pages/confirm-reset-password';
import { Contact } from 'pages/contact';
import { DisinfectionTechniques } from 'pages/disinfection-techniques';
import { Download } from 'pages/download';
import { EmailVeryficationError } from 'pages/email-verification-error';
import { EmailVeryficationSuccess } from 'pages/email-verification-success';
import { EmployeeManagement } from 'pages/employee-management';
import { GenerateCertificate } from 'pages/generate-certificate';
import { Home } from 'pages/home';
import { InternetExplorer } from 'pages/internet-explorer';
import { KnowledgeBase } from 'pages/knowledge-base';
import { Login } from 'pages/login';
import { GenericTopicPage } from 'pages/online-trainings/generic-topic';
import { OnlineTrainings } from 'pages/online-trainings';
import { HandHygiene } from 'pages/online-trainings/hand-hygiene';
import { CourseLayout } from 'pages/online-trainings/hand-hygiene/course-layout';
import { FiveMomentsHandHygiene } from 'pages/online-trainings/hand-hygiene/five-moments-hand-hygiene';
import { HandHygieneAndMedicalGloves } from 'pages/online-trainings/hand-hygiene/hand-hygiene-and-medical-gloves';
import { Inroduction } from 'pages/online-trainings/hand-hygiene/inroduction';
import { PreparingYourHandsToWork } from 'pages/online-trainings/hand-hygiene/preparing-your-hands-to-work';
import { ProperHandDisinfection } from 'pages/online-trainings/hand-hygiene/proper-hand-disinfection';
import { ProperHandWashing } from 'pages/online-trainings/hand-hygiene/proper-hand-washing';
import { HandHygieneQuiz } from 'pages/online-trainings/hand-hygiene/quiz';
import { Registration } from 'pages/registration';
import { RegistrationChoice } from 'pages/registration-choice';
import { RegistrationEmployee } from 'pages/registration-employee';
import { ResetAccessPage } from 'pages/reset-access';
import { ResetPasswordPage } from 'pages/reset-page';
import { ResetPassword } from 'pages/reset-password';
import { SetNewPassword } from 'pages/set-new-password';
import { Styleguide } from 'pages/styleguide';
import { SubmitYourOrder } from 'pages/submit-your-order';
import { Route, Routes } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { ProfileUpdate } from 'views/complete-profile';

function App() {
    const isIE = /*@cc_on!@*/ false || !!document['documentMode'];

    if (isIE) return <InternetExplorer />;

    return (
        <div className="App">
            <Layout>
                <Routes>
                    <Route path={PATHS.HOME} element={<Home />} />
                    <Route path={PATHS.LOGIN} element={<Login />} />
                    <Route
                        path={PATHS.REGISTER_CHOOSE}
                        element={<RegistrationChoice />}
                    />
                    <Route
                        path={PATHS.REGISTRATION}
                        element={<Registration />}
                    />
                    <Route
                        path={PATHS.REGISTRATION_EMPLOYEE}
                        element={<RegistrationEmployee />}
                    />
                    <Route
                        path={PATHS.RESET_PASSWORD_PAGE}
                        element={<ResetPasswordPage />}
                    />
                    <Route
                        path={PATHS.RESET_PASSWORD}
                        element={<ResetPassword />}
                    />
                    <Route
                        path={PATHS.RESET_ACCESS}
                        element={<ResetAccessPage />}
                    />
                    <Route
                        path={PATHS.CONFIRM_RESET_PASSWORD}
                        element={<ConfirmResetPassword />}
                    />
                    <Route
                        path={PATHS.SET_NEW_PASSWORD}
                        element={<SetNewPassword />}
                    />
                    <Route
                        path={PATHS.EMPLOYEE_MANAGMENT}
                        element={<EmployeeManagement />}
                    />
                    <Route
                        path={PATHS.EMAIL_VERIFICATION_SUCCESS}
                        element={<EmailVeryficationSuccess />}
                    />
                    <Route
                        path={PATHS.EMAIL_VERIFICATION_ERROR}
                        element={<EmailVeryficationError />}
                    />
                    <Route
                        path={PATHS.CONFIRM_EMAIL_ADDRESS}
                        element={<ConfirmEmailAddress />}
                    />
                    <Route
                        path={PATHS.ABOUT_ACTION}
                        element={<AboutAction />}
                    />
                    <Route
                        path={PATHS.KNOWLEDGE_BASE}
                        element={<KnowledgeBase />}
                    />
                    {process.env.NODE_ENV !== 'production' && (
                        <Route
                            path={PATHS.STYLEGUIDE}
                            element={<Styleguide />}
                        />
                    )}
                    <Route
                        path={PATHS.DISINFECTION_TECHNIQUES}
                        element={<DisinfectionTechniques />}
                    />
                    <Route path={PATHS.CONTACT} element={<Contact />} />
                    <Route
                        path={`${PATHS.ONLINE_TRAININGS}/:coursePath/:issuePath`}
                        element={<CourseLayout />}
                    >
                        <Route path=":topicPath" element={<GenericTopicPage />} />
                    </Route>
                    <Route
                        path={PATHS.ONLINE_TRAININGS}
                        element={<OnlineTrainings />}
                    />
                    <Route
                        path={`${PATHS.ONLINE_TRAININGS}/:coursePath`}
                        element={<HandHygiene />}
                    />
                    <Route
                        path={PATHS.GENERATE_CERTIFICATE}
                        element={<GenerateCertificate />}
                    />
                    <Route
                        path={PATHS.DOWNLOAD}
                        element={
                            <PrivateRoute permission="premium">
                                <Download />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path={PATHS.BASKET}
                        element={
                            <PrivateRoute permission="premium">
                                <Basket />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path={PATHS.SUBMIT_YOUR_ORDER}
                        element={
                            <PrivateRoute permission="premium">
                                <SubmitYourOrder />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path={PATHS.COMPLETE_PROFILE}
                        element={
                            <PrivateRoute>
                                <ProfileUpdate />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </Layout>
        </div>
    );
}

export default App;
